import {atom} from 'jotai'
import {ListFilter, TerminalList} from '../domain'

const list: TerminalList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 1,
    totalCount: 0,
  },
}

export const listAtom = atom<TerminalList>(list)
export const listFilterAtom = atom<ListFilter>({
  filterList: [],
  orderList: [{type: 2, key: 'CreatedDate'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})
